import { ConfigProvider as AntdConfigProvider } from 'antd';
import { changeTheme, getSystemTheme } from 'utils';
import getAntThemeConfig from 'configs/antd.theme.config';
import { ThemeModeProvider } from 'contexts/theme-mode-context';
import { useEffect, useState } from 'react';
import { ConfigProvider as ReactAvatarConfigProvider } from 'react-avatar';
import { Provider, useSelector } from 'react-redux';
import { PersistGate } from 'redux-persist/integration/react';
import { getLocalStorage } from 'utils/cookies-util';
import './App.css';
import { avatarColors } from './constants/generic-lists';
import ElevateRoutes from './router';
import { persistor, store } from './store';
import './styles/antd.customize.scss';
import './styles/utils.scss';
import { selectCurrentTenant } from 'reducers/selectors';

const ThemedApp = ({ themeMode = '' }) => {
  const { tenantData } = useSelector(selectCurrentTenant);

  useEffect(() => {
    changeTheme(themeMode);
  }, [themeMode]);

  return (
    <AntdConfigProvider theme={getAntThemeConfig(themeMode, tenantData)}>
      <ReactAvatarConfigProvider colors={avatarColors}>
        <ElevateRoutes />
      </ReactAvatarConfigProvider>
    </AntdConfigProvider>
  );
};

const App = () => {
  const [themeMode, setThemeMode] = useState(() => {
    return getLocalStorage('theme') || getSystemTheme();
  });

  return (
    <Provider store={store}>
      <PersistGate loading={null} persistor={persistor}>
        <ThemeModeProvider
          value={{
            setThemeMode: setThemeMode,
            themeMode: themeMode,
          }}
        >
          <ThemedApp themeMode={themeMode} />
        </ThemeModeProvider>
      </PersistGate>
    </Provider>
  );
};

export default App;
